import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CampaignCreationSlideContainer from "../../../components/CampaignCreation/CampaignCreationSlideContainer";
import SavedZipCodes from "./components/SavedZipCodes";
import ZipCodesInput from "./components/ZipCodesInput";
import classes from "./ZipCodeSelectionSlide.module.scss";
import { BaseStepComponentProps } from "../../../components/modules/BaseStepper/BaseStepper";
import { ReduxApplicationState } from "../../../types/ReduxTypes/ReduxApplicationState";
import { errorToaster } from "../../../helpers/toasters";
import { setSelectedZipCodes } from "../../../redux/reducers/campaignToCreate";

const ZipCodeSelectionSlide: FC<BaseStepComponentProps> = ({
  isAttemptingToGoNext,
  setIsAttemptingToGoNext,
  handleNext,
}) => {
  const selectedZipCodes = useSelector((state: ReduxApplicationState) => state.campaignToCreate.selectedZipCodes);
  const [zipCodes, setZipCodes] = useState<string[]>(selectedZipCodes);

  const dispatch = useDispatch();

  const handleSaveZipCodes = (enteredZipCodes: string) => {
    const trimmedZipZodes = enteredZipCodes
      .split(" ")
      .map((zip: string) => zip.replace(",", "").trim())
      .filter((str) => str);

    const uniqueZipCodes = [...new Set(trimmedZipZodes)];
    setZipCodes(uniqueZipCodes);
  };

  useEffect(() => {
    if (isAttemptingToGoNext) {
      if (zipCodes.length !== 0) {
        dispatch(setSelectedZipCodes(zipCodes));
        handleNext();
        setIsAttemptingToGoNext(false);
      } else {
        errorToaster("Please, enter the required zip codes.", 5000);
        setIsAttemptingToGoNext(false);
      }
    }
  }, [dispatch, handleNext, isAttemptingToGoNext, setIsAttemptingToGoNext, zipCodes, zipCodes.length]);

  return (
    <CampaignCreationSlideContainer heading="Campaign Zip Code Selection">
      <div className={classes.container}>
        <ZipCodesInput handleSaveZipCodes={handleSaveZipCodes} />
        {zipCodes.length !== 0 ? <SavedZipCodes zipCodes={zipCodes} /> : null}
      </div>
    </CampaignCreationSlideContainer>
  );
};

export default ZipCodeSelectionSlide;
